<template>
    <div class="calendar__header">
        <button class="calendar__header--button prev" @click="prevCalendar"><img src="@/assets/resource/icon/arrow.svg" alt=""></button>
        <h4 class="calendar__header--title">{{calYear}}.{{calMonth}}</h4>
        <button class="calendar__header--button next" @click="nextCalendar"><img src="@/assets/resource/icon/arrow.svg" alt=""></button>
    </div>
    <div class="month__calendar">
        <table>
            <thead>
                <tr>
                    <th>Sun</th>
                    <th>Mon</th>
                    <th>Tue</th>
                    <th>Wed</th>
                    <th>Thu</th>
                    <th>Fri</th>
                    <th>Sat</th>
                </tr>
            </thead>
            <tbody>
                <!-- today: 금일 / pos: 예약가능 / active: 선택 -->
                <tr v-for="item in arrChunk(calendarList)" :key="item">
                    <td v-for="(i, idx) in item" :key="i" :class="[i.dayType, {'c-red' : idx == '0'}, {'c-blue' : idx == '6'}]">
                        <component :is="reserve == 'Y' && i.dayType.indexOf('full') > 0 ? 'a' : 'div' "
                                   href="javascript:;"
                        >
                            <div :class="{'full-box': true, 'today': i.dayType === 'today' }">
                                <button type="button" class="full-box" v-if="i.calClass"
                                        :class="{'today': i.dayType === 'today', [i.calClass]: i.calClass, 'pick' : i.text == activeIndex}"
                                        :disabled="i.dayType == 'end'">
                                    <span class="num">{{i.day}}</span>
                                </button>
                                <span class="num" v-else>{{i.day}}</span>
                                <div class="date-box">
                                    <template v-for="ampm in i.ampm">
                                        <span class="free" v-if="ampm.NSP_RSN_TP_CD == 'Y'">Закрыто</span>
                                        <span class="am" v-else-if="ampm.NSP_RSN_TP_CD != 'Y' && ampm.MED_TP == '오전'">A.M</span>
                                        <span class="pm" v-else-if="ampm.NSP_RSN_TP_CD != 'Y' && ampm.MED_TP == '오후'">P.M</span>
                                    </template>
                                </div>
                            </div>
                        </component>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
export default {
    props: {
        // array object
        // ex: [{text: '20240505', dayType: 'pos'}]
        classList: '',
        reserve: {
            type: String,
            required: false
        },
        selDate: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            startDate: '',
            endDate: '',
            today: new Date(),
            calendarList: '',
            calYear: '',
            calMonth: '',
            activeIndex: '',
            flag: false
        }
    },
    watch: {
        classList(newVal) {
            this.init();
        }
    },
    created() {
        this.init();
    },
    methods: {
        /**
         * 이번 달의 첫 날, 마지막 날 구하기
         */
        init(){
            if(this.selDate && !this.flag){
                // this.setCalendar(this.selDate)
                this.today = new Date(this.selDate.slice(0,4), (this.selDate.slice(4,6) - 1), 1);
                this.flag = true
            
                this.setActiveIndex(this.selDate)
            }
            this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
            this.endDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);

            this.createCalendar();

        },
        /**
         * 달력 생성
         */
        createCalendar(){
            this.activeIndex = ''
            this.calendarList = [];
            this.calYear = this.today.getFullYear();
            this.calMonth = this.$commonUtils.leftPad(this.today.getMonth() + 1);

            if(this.startDate.getDay() > 0){
                let preLastSunDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), ((this.startDate.getDay() - 1) * -1));
                let preLastDate = new Date(preLastSunDate.getFullYear(), preLastSunDate.getMonth() + 1, 0);

                // 지난달 구하기
                for (let preDay = preLastSunDate; preDay <= preLastDate; preDay.setDate(preDay.getDate() + 1)) { 
                    let date = {
                        year : preDay.getFullYear(),
                        month : this.$commonUtils.leftPad(preDay.getMonth() + 1),
                        // day : this.$commonUtils.leftPad(preDay.getDate()),
                        day : preDay.getDate(),
                        week : preDay.getDay(), // 0~6
                        text : this.$commonUtils.dateToStr(preDay, ''),
                        dayType : 'dim'
                    }

                    this.calendarList.push(date);
                }
            }

            let today = new Date();
            today.setHours(0, 0, 0, 0); // 시간 초기화

            // 이번달 구하기
            for (let nowDay = this.startDate; nowDay <= this.endDate; nowDay.setDate(nowDay.getDate() + 1)) { 
                let date = {
                    year : nowDay.getFullYear(),
                    month : this.$commonUtils.leftPad(nowDay.getMonth() + 1),
                    // day : this.$commonUtils.leftPad(nowDay.getDate()),
                    day : nowDay.getDate(),
                    week : nowDay.getDay(),
                    text : this.$commonUtils.dateToStr(nowDay, ''),
                    dayType : ''
                }

                if (nowDay < today) {
                    date.dayType = "pastDay";
                } else if (nowDay.getFullYear() == today.getFullYear() 
                            && nowDay.getMonth() == today.getMonth() && nowDay.getDate() == today.getDate()) {    
                    date.dayType = "today";
                }else {
                    date.dayType = "futureDay";
                }

                this.calendarList.push(date);
            }
           
            // 다음달 구하기
            if(this.endDate.getDay() < 6){
                let nextFirstDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 1);
                let nextFirstSunDate = new Date(nextFirstDate.getFullYear(), nextFirstDate.getMonth(), ((this.endDate.getDay() - 7 ) * -1) -1);
                
                for (let nextDay = nextFirstDate; nextDay <= nextFirstSunDate; nextDay.setDate(nextDay.getDate() + 1)) { 
                    let date = {
                        year : nextDay.getFullYear(),
                        month : this.$commonUtils.leftPad(nextDay.getMonth() + 1),
                        // day : this.$commonUtils.leftPad(nextDay.getDate()),
                        day : nextDay.getDate(),
                        week : nextDay.getDay(),
                        text : this.$commonUtils.dateToStr(nextDay, ''),
                        dayType : 'dim'
                    }

                    this.calendarList.push(date);
                }
            }

            // dayType에 class 부여
            if(this.classList){

                // classList에서 오늘 날짜 이전은 제외처리, classList에 text로 (yyyyMMDD)로 들어가 있음
                const today = new Date();
                const todayStr = this.$commonUtils.dateToStr(today, '');

                const finalClassList = this.classList.filter(item => item.text > todayStr);

                for(let i of this.calendarList){
                    for(let j of finalClassList){
                        if(i.text == j.text){
                            i.dayType += ` ${j.dayType}`
                            i.calClass = j.calClass
                            i.ampm = i.ampm || []
                            if(j.MED_TP && j.NSP_RSN_TP_CD){
                                const obj = {}
                                obj.MED_TP = j.MED_TP
                                obj.NSP_RSN_TP_CD = j.NSP_RSN_TP_CD
                                i.ampm.push(obj)
                            }
                        }
                    }
                }
            }
        },
        todayCalendar(){
            this.today = new Date();
            this.init();
        },
        prevCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1);
            if(this.$parent.selectedDoctor){
                this.$emit('getClass', this.$parent.selectedDoctor, `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }else{
                this.$emit('getClass', `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }
            this.init();
        },
        nextCalendar(){
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            if(this.$parent.selectedDoctor){
                this.$emit('getClass', this.$parent.selectedDoctor, `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }else{
                this.$emit('getClass', `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }
            this.init();
        },
        /**
         * ref) 원하는 날짜로 달력을 세팅
         * @param date(yyyyMMdd)
         */
        setCalendar(date){
            const year = date.slice(0,4)
            const month = date.slice(4,6)
            this.today = new Date(year, month - 1, 1);
            if(this.$parent.selectedDoctor){
                this.$emit('getClass', this.$parent.selectedDoctor, `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }else{
                this.$emit('getClass', `${this.today.getFullYear()}${this.$commonUtils.leftPad(this.today.getMonth()+1)}`)
            }
            this.init();
        },
        arrChunk(arr){
            return arr.reduce(function (acc, val, index) {
                const chunkIndex = Math.floor(index / 7);
                if (!acc[chunkIndex]) {
                    acc[chunkIndex] = [];
                }
                acc[chunkIndex].push(val);
                return acc;
            }, []);
        },
        callParentFunction(i){
            if(i.calClass != 'end') this.activeIndex = i.text
            this.$emit('clickFnc', i);
        },
        setActiveIndex(idx){
            this.activeIndex = idx
        },
        selectDate(i){
            this.setActiveIndex(i.text)
            this.$emit('selectDate', i)
        },
        reservation(i){
            this.$store.state.reserveStore.normalReserve = this.$parent.info
            this.$store.state.patInfoStore = {}

            this.$store.state.reserveStore.normalReserve.date = i.text

            this.$router.push('/kr/reserve/reservation')

        }
    }
}
</script>

<style>
.end {
    cursor: not-allowed;  /* 마우스를 올리면 '비활성화된' 커서로 변경 */
    pointer-events: none;  /* 클릭이나 마우스 이벤트를 비활성화 */
}
</style>